/**
 * Per-dev Indy (AgentChat) Lambda sandbox URLs, keyed by the dev's Cognito
 * sign-in email (spec §18 of specs/ecs-dev-sandboxes.md). The Indy header's
 * dev-only toggle reads this, so devs flip to their sandbox without pasting.
 *
 * Function URLs carry a random id fixed at creation: add yours after
 * `./sandbox.sh indy-lambda create` (it prints the URL; `./sandbox.sh indy-lambda url`
 * re-prints it). It only changes if the sandbox stack is destroyed.
 */
export const INDY_SANDBOX_URLS: Record<string, string> = {
  "duo@getindigo.io":
    "https://iytttnmofxjw54mklv7jhg2f2e0ivojb.lambda-url.us-east-1.on.aws/",
  "haoyun@getindigo.io":
    "https://rygnt5jquhk6wntmqmi7ulp3tm0aehbj.lambda-url.us-east-1.on.aws/",
};
